/**
 * @desc 使用场景：撮合成交模态框: 中标车辆的撮合成交
 *
 * 组件使用方式 ->
 * import {WinningBrokeredDeal} from '@/components';
 * <WinningBrokeredDeal
 *      visibleUseComponent=boolean    // 是否展示弹框 true 展示； false 隐藏
 *      objUseComponent: {
 *        orderId: string;                // 订单id
 *        winningPrice: string|number,    // 中标价
 *        commission: string|number,      // 佣金
 *        servicePrice: string|number,    // 服务费
 *        handPrice: string|number,       // 合手价
 *        showTransferWay?: boolean,      // 是否展示过户方式 true 展示； false 隐藏，默认展示
 *        onOk?: (id ?: any ) => void;    // 成功之后回调 id默认是orderId
 *      };
 * />
 *
 * API使用    ->
 * API:import { ShowBrokeredDeal } from '@/shared/utils';
 * ShowBrokeredDeal({
 *     orderId: string;                    // 订单id
 *     winningPrice: Iprice,               // 中标价
 *     commission: Iprice,                 // 佣金
 *     servicePrice: Iprice,               // 服务费
 *     handPrice: Iprice,                  // 合手价
 *     showTransferWay?: boolean,          // 是否展示过户方式 true 展示； false 隐藏，默认展示
 *     callback?: (id ?: any ) => void;    // 成功之后回调
 * })
 * */
import React, { Component } from 'react';
import store, { dispatch } from '@@/store';
import { Modal, Form, Input, Radio } from 'antd';
import ReactDOM from 'react-dom';
import { CHECK_Money7, CHECK_name } from '@/shared/reqexp';
import InputNum from './components/InputNum';
import { connect, Provider } from '@souche-f2e/muji';
import { toNumberOrEmpty } from '@/shared/functions';
const mapStateToProps = (rootState) => ({
    _state: rootState.brokeredDealWinning,
});
class BrokeredDealTemp extends Component {
    constructor() {
        super(...arguments);
        this.handleOk = () => {
            // 点击确认
            dispatch.brokeredDealWinning.handleOk(this.props);
        };
        this.handleCancel = () => {
            // 点击取消
            dispatch.brokeredDealWinning.handleCancel({});
        };
        this.handleClose = () => {
            // 模态框关闭之后
            dispatch.brokeredDealWinning.handleClose(this.props);
        };
        this.handleInput = (type) => {
            // 清除红框提示
            const { winningPrice, servicePrice, commission } = this.props.form.getFieldsValue();
            const _obj = {
                winningPrice: { value: winningPrice },
                servicePrice: { value: servicePrice },
                commission: { value: commission },
            };
            delete _obj[type];
            this.props.form.setFields(_obj);
            dispatch.brokeredDealWinning.SET_STATE({ notEqualToHandPrice: false });
        };
    }
    componentWillMount() {
        // 如果使用组件方式, 处理赋值或加载数据；如果不是，则不操作
        dispatch.brokeredDealWinning.dealUseComponent(this.props);
    }
    componentWillReceiveProps(nextProps) {
        // 如果使用组件方式, 并且visibleUseComponent变化 处理赋值或加载数据；如果不是，则不操作
        // 赋值条件容错场景： visibleUseComponent有定义但不变化的情况下操作关闭弹窗
        const { visibleUseComponent: oldV } = this.props;
        const { visibleUseComponent: newV } = nextProps;
        if (oldV !== undefined && oldV !== newV) {
            dispatch.brokeredDealWinning.dealUseComponent(nextProps);
        }
    }
    render() {
        const { form, _state } = this.props;
        const { getFieldDecorator } = form;
        const { notEqualToHandPrice, showBrokeredDeal, winningPrice, commission, servicePrice, handPrice, showTransferWay } = _state;
        return (<Modal title="撮合成交" visible={showBrokeredDeal} okText="保存" onOk={this.handleOk} cancelText="取消" onCancel={this.handleCancel} afterClose={this.handleClose} destroyOnClose={true}>
        <div style={{ fontWeight: 'bold' }}>
          <span>合手价：{handPrice}元</span>
          <span style={notEqualToHandPrice ? { color: 'red' } : {}}>（调整后的中标价+佣金+服务费需等于合手价）</span>
        </div>
        <Form style={{ marginTop: '20px' }} labelCol={{ span: 4 }} wrapperCol={{ span: 17 }} labelAlign="left">
          <Form.Item label="中标价">
            {getFieldDecorator('winningPrice', {
            rules: [
                { required: true, message: '请输入中标价' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(winningPrice),
        })(<InputNum onChange={() => this.handleInput('winningPrice')}/>)}
          </Form.Item>
          <Form.Item label="佣&emsp;金">
            {getFieldDecorator('commission', {
            rules: [
                { required: true, message: '请输入佣金' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(commission),
        })(<InputNum onChange={() => this.handleInput('commission')}/>)}
          </Form.Item>
          <Form.Item label="服务费">
            {getFieldDecorator('servicePrice', {
            rules: [
                { required: true, message: '请输入服务费' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: toNumberOrEmpty(servicePrice),
        })(<InputNum onChange={() => this.handleInput('servicePrice')}/>)}
          </Form.Item>
          
          {showTransferWay &&
            <Form.Item label="过户方式">
              {getFieldDecorator('transferType', {
                rules: [
                    { required: true, message: '请选择过户方式' },
                ],
                initialValue: 3,
            })(<Radio.Group>
                  <Radio value={2}>卖方过户</Radio>
                  <Radio value={3}>买方过户</Radio>
                </Radio.Group>)}
            </Form.Item>}
          <Form.Item label="备注" wrapperCol={{ span: 20 }}>
            {getFieldDecorator('remark', {
            rules: [
                { validator: CHECK_name(200) },
            ],
        })(<Input.TextArea className="delTextAreaRightDown" rows={4} placeholder="请输入更改原因（选填，100字内）"/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
}
const BrokeredDeal = Form.create()(BrokeredDealTemp);
const BrokeredDealComponent = connect(mapStateToProps, null, null, { forwardRef: true })(BrokeredDeal);
export default BrokeredDealComponent;
let componentRef = '';
const createBrokeredDeal = () => {
    const div = document.createElement('div');
    div.className = 'souche-break-contract';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(BrokeredDealComponent, {
        // @ts-ignore
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function ShowBrokeredDeal({ winningPrice, commission, servicePrice, handPrice, showTransferWay, orderId, callback }) {
    if (!componentRef) {
        createBrokeredDeal();
    }
    dispatch.brokeredDealWinning.ShowModal({ winningPrice, commission, servicePrice, handPrice, showTransferWay, orderId, callback });
}
